export const Types = {
    GET_AREAS: "GET_AREAS",
    GET_MAINTENANCE_TYPE: "GET_MAINTENANCE_TYPE",
    GET_AM_ORDER_DETAIL_BY_ID: "GET_AM_ORDER_DETAIL_BY_ID",
    AM_UPDATE_ORDER: "AM_UPDATE_ORDER",
    AM_CREATE_ORDER: "AM_CREATE_ORDER",
    GET_AM_ORDER_FILES: "GET_AM_ORDER_FILES",
    POST_AM_ADD_FILES: "POST_AM_ADD_FILES",
    AM_UPDATE_SUCCESS: "AM_UPDATE_SUCCESS",
    CREATE_FAILURE: "CREATE_FAILURE",
    RESET_LIST: "RESET_LIST",

    SET_AREAS: "SET_AREAS",
    SET_MAINTENANCE_TYPE: "SET_MAINTENANCE_TYPE",
    SET_AM_ORDER_DETAIL_BY_ID: "SET_AM_ORDER_DETAIL_BY_ID",
    AM_CREATE_ORDER_SUCCESS: "AM_CREATE_ORDER_SUCCESS",
    AM_UPDATE_ORDER_SUCCESS: "AM_UPDATE_ORDER_SUCCESS",
    AM_UPDATE_ORDER_SUCCESS_AFTER: "AM_UPDATE_ORDER_SUCCESS_AFTER",
    SET_AM_ORDER_FILES: "SET_AM_ORDER_FILES",
    POST_AM_ADD_FILES_SUCCESS: "POST_AM_ADD_FILES_SUCCESS",
    AM_CREATE_ORDER_SUCCESS_AFTER: "AM_CREATE_ORDER_SUCCESS_AFTER",

    GET_AM_ORDER_LIST: "GET_AM_ORDER_LIST",
    SET_AM_ORDER_LIST: "SET_AM_ORDER_LIST",
    DELETE_AM_ORDER: "DELETE_AM_ORDER",
    DELETE_ORDER_AM: "DELETE_ORDER_AM",
    DELETE_AM_ORDER_SUCCESS: "DELETE_AM_ORDER_SUCCESS",
    AM_DELETE_ORDER_SUCCESS_AFTER: "AM_DELETE_ORDER_SUCCESS_AFTER",
    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",

    GET_CHECKITEMGROUPS_BY_ORDERID: "GET_CHECKITEMGROUPS_BY_ORDERID",
    SET_CHECKITEMGROUPS_BY_ORDERID: "SET_CHECKITEMGROUPS_BY_ORDERID",

    GET_CHECKITEMS_FOR_TASK: "GET_CHECKITEMS_FOR_TASK",
    SET_CHECKITEMS_FOR_TASK: "SET_CHECKITEMS_FOR_TASK",
    PUT_CHECKITEMS_FOR_TASK: "PUT_CHECKITEMS_FOR_TASK",
    RESET_AM_ORDER_LIST: "RESET_AM_ORDER_LIST",
    RESET_AM_ORDER_DETAIL_BY_ID: "RESET_AM_ORDER_DETAIL_BY_ID",
    RESET_DELETE_ORDER_AM: "RESET_DELETE_ORDER_AM",
};

export const getAreaList = () => ({
    type: Types.GET_AREAS,
});

export const setAreaList = (payload) => ({
    type: Types.SET_AREAS,
    payload,
});

export const getMaintenanceType = () => ({
    type: Types.GET_MAINTENANCE_TYPE,
});

export const setMaintenanceType = (payload) => ({
    type: Types.SET_MAINTENANCE_TYPE,
    payload,
});

export const getAMGetOrderDetailById = (payload) => ({
    type: Types.GET_AM_ORDER_DETAIL_BY_ID,
    payload,
});

export const setAMGetOrderDetailById = (payload) => ({
    type: Types.SET_AM_ORDER_DETAIL_BY_ID,
    payload,
});

export const postAMCreateOrder = (payload) => ({
    type: Types.AM_CREATE_ORDER,
    payload,
});

export const deleteAMOrder = (payload) => ({
    type: Types.DELETE_ORDER_AM,
    payload,
});

export const postAMCreateOrderSuccess = (payload) => ({
    type: Types.AM_CREATE_ORDER_SUCCESS,
    payload,
});

export const postAMUpdateOrder = (payload) => ({
    type: Types.AM_UPDATE_ORDER,
    payload,
});

export const postAMUpdateOrderSuccess = (payload) => ({
    type: Types.AM_UPDATE_ORDER_SUCCESS,
    payload,
});

export const getAMGetOrderFiles = (payload) => ({
    type: Types.GET_AM_ORDER_FILES,
    payload,
});

export const setAMGetOrderFiles = (payload) => ({
    type: Types.SET_AM_ORDER_FILES,
    payload,
});

export const postAMAddFile = (payload) => ({
    type: Types.POST_AM_ADD_FILES,
    payload,
});

export const postAMAddFileSuccess = (payload) => ({
    type: Types.POST_AM_ADD_FILES_SUCCESS,
    payload,
});

export const amUpdateOrderSuccess = () => ({
    type: Types.AM_UPDATE_SUCCESS,
});

export const amCreateOrderAfter = (payload) => ({
    type: Types.AM_CREATE_ORDER_SUCCESS_AFTER,
    payload,
});

export const amUpdateOrderAfter = () => ({
    type: Types.AM_UPDATE_ORDER_SUCCESS_AFTER,
});

export const getAMOrderList = () => ({
    type: Types.GET_AM_ORDER_LIST,
});

export const setAMOrderList = (payload) => ({
    type: Types.SET_AM_ORDER_LIST,
    payload,
});

export const deleteOrderAM = (payload) => ({
    type: Types.DELETE_ORDER_AM,
    payload,
});

export const amDeleteOrderAfter = (payload) => ({
    type: Types.AM_DELETE_ORDER_SUCCESS_AFTER,
    payload,
});

export const deleteAMOrderSuccess = (payload) => ({
    type: Types.DELETE_AM_ORDER_SUCCESS,
    payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});

export const getCheckItemGroupsById = (payload) => ({
    type: Types.GET_CHECKITEMGROUPS_BY_ORDERID,
    payload,
});

export const setCheckItemGroupsById = (payload) => ({
    type: Types.SET_CHECKITEMGROUPS_BY_ORDERID,
    payload,
});

export const getCheckItemsForTask = (payload) => ({
    type: Types.GET_CHECKITEMS_FOR_TASK,
    payload,
});

export const setCheckItemsForTask = (payload) => ({
    type: Types.SET_CHECKITEMS_FOR_TASK,
    payload,
});

export const putCheckItemsForTask = (payload) => ({
    type: Types.PUT_CHECKITEMS_FOR_TASK,
    payload,
});

// Reset
export const resetAMOrderList = () => ({
    type: Types.RESET_AM_ORDER_LIST,
});

export const resetAMGetOrderDetailById = () => ({
    type: Types.RESET_AM_ORDER_DETAIL_BY_ID,
});

export const resetDeleteOrderAM = () => ({
    type: Types.RESET_DELETE_ORDER_AM,
});

